module.exports = __webpack_public_path__ + "img/0ec1c4f.png";